import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { LayoutSidebarSubnav } from 'core/components';

import PageOrganizationsList from 'hcp/components/page/organizations/list';

<template>
  {{pageTitle (t "page-title.organizations.list")}}

  <LayoutSidebarSubnav as |Subnav|>
    <Subnav.Link
      @text={{t "components.page.organizations.list.title"}}
      @route="cloud.orgs"
    />
  </LayoutSidebarSubnav>

  <PageOrganizationsList
    @contractActivation={{@controller.contractActivation}}
    @model={{@controller.model}}
  />
</template>
